import axios from 'axios';
import ScatterJS from 'scatterjs-core';
import ScatterEOS from 'scatterjs-plugin-eosjs';
import Eos from 'eosjs';

// Store modules
import auth from './auth';

// Init Scatter
ScatterJS.plugins( new ScatterEOS() );

// Networks are used to reference certain blockchains.
// They let you get accounts and help you build signature providers.
const network = {
  blockchain:'eos',
  protocol:'https',
  host:'jungle2.cryptolions.io',
  port:443,
  chainId:'e70aaab8997e1dfce58fbfac80cbbb8fecec7b99cf982a9444273cbc64c41473'
}

var AmazonCognitoIdentity = require('amazon-cognito-identity-js');
var CognitoUserPool = AmazonCognitoIdentity.CognitoUserPool;

// initial state
const state = {
    stagedWasmFile: {},
    stagedAbiFile: {}
}

const getters = {
    
}

const mutations = {
    stageWasm(state, wasm) {
        console.log(wasm)
        state.stagedWasmFile = wasm
        console.log(state.stagedWasmFile)
    },
    stageAbi(state, abi) {
        console.log(abi)
        state.stagedAbiFile = abi
        console.log(state.stagedAbiFile)
    }
}

const actions = {
    prepareContractCode(context) {
       auth.state.getSession.then((token) => {
          // console.log(token.accessToken.jwtToken)
          var config = {
          headers: {'Authorization': "bearer " + token.accessToken.jwtToken, 
                    'accesstoken': token.accessToken.jwtToken}
          };
          var bodyParameters = {
             key: "value"
          }
      // .get(axios.get('http://ec2-54-188-220-40.us-west-2.compute.amazonaws.com/grabWasm/'))
      // .then(axios.get('http://ec2-54-188-220-40.us-west-2.compute.amazonaws.com/grabAbi/'))
          console.log("IM HITTING THE CONTRACT")
          axios
            .post('http://ec2-52-41-198-74.us-west-2.compute.amazonaws.com/grabWasm/', bodyParameters, config)
            .then(wasm => (context.commit('contractBuild/stageWasm', wasm, { root: true })))
            .then(axios.post('http://ec2-52-41-198-74.us-west-2.compute.amazonaws.com/grabAbi/', bodyParameters, config))
            .then(abi => (context.commit('contractBuild/stageAbi', abi, { root: true })))
            .then(() => { return true})
        })
    },
    deployContract(context) {
        ScatterJS.scatter.connect('My-App').then(connected => {

              // If the user does not have Scatter or it is Locked or Closed this will return false;
              if(!connected) return false;

              const scatter = ScatterJS.scatter;

              // Now we need to get an identity from the user.
              // We're also going to require an account that is connected to the network we're using.
              const requiredFields = { accounts:[network] };
              scatter.getIdentity(requiredFields).then(() => {

                  // Always use the accounts you got back from Scatter. Never hardcode them even if you are prompting
                  // the user for their account name beforehand. They could still give you a different account.
                  const account = scatter.identity.accounts.find(x => x.blockchain === 'eos');

                  // You can pass in any additional options you want into the eosjs reference.
                  const eosOptions = { expireInSeconds:60 };

                  // Get a proxy reference to eosjs which you can use to sign transactions with a user's Scatter.
                  const eos = scatter.eos(network, Eos, eosOptions);

                  // ----------------------------
                  // Now that we have an identity,
                  // an EOSIO account, and a reference
                  // to an eosjs object we can send a transaction.
                  // ----------------------------


                  // Never assume the account's permission/authority. Always take it from the returned account.
                  const transactionOptions = { authorization:[`${account.name}@${account.authority}`] };

                  console.log(state)
                  console.log(context)
                  eos.setcode(account.name, 0, 0, Buffer.from(context.state.stagedWasmFile.data), transactionOptions).then(trx => {
                    eos.setabi(account.name, JSON.parse(Buffer.from(context.state.stagedAbiFile.data)), transactionOptions).then(trx => {
                        // That's it!
                        console.log(`Transaction ID: ${trx.transaction_id}`);
           
                        setTimeout(function(){
                          eos.contract(account.name).then(contract => {  // contract account needs to change when going to jungle..
                            contract.create(account.name, 1, '110.00', '210.00', '140.00', '100.00', 'cool place', transactionOptions)
                        }).catch(e => {
                            console.log("error", e);
                        })
                        }, 2000)

                   
                    }).catch(error => {
                        console.error(error);
                    });
                      console.log(`Transaction ID: ${trx.transaction_id}`);
                  }).catch(error => {
                      console.error(error);
                  });

              }).catch(error => {
                  // The user rejected this request, or doesn't have the appropriate requirements.
                  console.error(error);
              });
          })
    }

}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}